// accordion js
$(document).ready(() => {
  const $window = $(window);
  const $sections = $(".collapsible-content-v1 .collapsible-content"); // Select all sections
  const $accordionTitles = $(".collapsible-content-v1 .accordion-title-wrap"); // Select all accordion titles

  function checkSectionHeight() {
    const windowHeight = $window.height();
    const threshold = windowHeight * 0.75;

    $sections.each((index, section) => {
      const $section = $(section);
      const sectionHeight = $section.outerHeight();

      if (sectionHeight > threshold) {
        $section.addClass("has-sticky"); // Add your class name here
      } else {
        $section.removeClass("has-sticky"); // Remove your class name here
      }
    });
  }

  // Check on resize and scroll events
  $window.on("resize", checkSectionHeight);

  // Check when clicking on accordion titles
  $accordionTitles.on("click", () => {
    setTimeout(checkSectionHeight, 300); // Adjust delay as needed
  });

  // Initial check
  checkSectionHeight();

  $(document).on("click", ".mobile_tab_nav", function (event) {
    event.preventDefault();
    let tab_name = $(this).data("tab");

    // Toggle active class for mobile tab nav
    $(".mobile_tab_nav").removeClass("active");
    $(this).addClass("active");

    // Toggle active class for nav items
    $(".nav__item").addClass("small-hide").removeClass("tab-active");
    $(`.nav__item#${tab_name}`)
      .removeClass("small-hide")
      .addClass("tab-active");
  });

  $(document).on("click", ".ideas_box .idea", function () {
    let suggestion_text = $(this).text();
    $('.search__input[name="q"]').val("");
    $('.search__input[name="q"]').val(suggestion_text);
    $('.search__input[name="q"]').focus();
  });

  $(".collapsible-content__grid").each(function () {
    const grid = $(this);

    grid.find(".accordion-title-wrap").on("click", function () {
      const parentWrap = $(this).closest(".accordion");
      const isActive = parentWrap.hasClass("active");

      // Collapse all accordions within this specific grid
      grid
        .find(".accordion")
        .removeClass("active")
        .find(".accordion__content")
        .slideUp("fast");

      // Expand the clicked accordion if it wasn't active
      if (!isActive) {
        parentWrap.addClass("active");
        parentWrap.find(".accordion__content").slideDown("fast");
      }
    });
  });

  $('.aboutUs-sec-v1 .multicolumn-list a[href^="#"]').on("click", function (e) {
    e.preventDefault();
    var target = this.hash;
    var $target = $(target);
    // Task 131588: bail out instead of throwing when the section this links to
    // is missing or disabled on the page (offset() is undefined for an empty set).
    if (!$target.length) return;
    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: $target.offset().top - 100,
        },
        900,
        "swing",
        function () {
          // window.location.hash = target;
        }
      );
  });

  $(document).on(
    "click",
    ".lookbook-section .lookbook-prodcut-card",
    function (e) {
      // Check if the click is inside .product-card-wrapper
      if ($(e.target).closest(".product-card-wrapper").length > 0) {
        // Do nothing if clicked inside .product-card-wrapper
        return;
      }

      // Otherwise, toggle class on the child .all-prodcut-card-wrap
      const childCard = $(this).find(".all-prodcut-card-wrap");
      childCard.toggleClass("show-products");
    }
  );

  $(document).on(
    "click",
    ".predictive-search__heading .view_all_link",
    function () {
      let $this = $(this);
      $this.siblings('input[type="checkbox"]').prop("checked", true);
    }
  );

  let search_type = getParameterByName("type");
  if (search_type) {
    var pagehandle = $("#" + search_type).offset().top - 150;
    $("html, body").animate(
      {
        scrollTop: pagehandle,
      },
      800
    );
  }

  $(document).on("click","#predictive-search-option-search-keywords .search-modal__close-button",function () {
      $("predictive-search").siblings(".search-modal__close-button").trigger("click");
      $("predictive-search").find(".reset__button").trigger("click");
    }
  );

  $('.multicolumn-col-v4 a[href^="#"]').on("click", function (e) {
    e.preventDefault();
    var target = this.hash;
    var $target = $(target);
    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: $target.offset().top,
        },
        900,
        "swing",
        function () {
          // window.location.hash = target;
        }
      );
  });

  const setupAccordion = () => {
    if (window.innerWidth <= 768) {
      $(".sizeguide-table-col").each(function () {
        $(this).find(".sizeguide-col-item:not(:first-child)").hide();
        $(this).removeClass("active");
      });

      $(".sizeguide-table-col .sizeguide-col-item:first-child")
        .off("click")
        .on("click", function () {
          const $clickedCol = $(this).closest(".sizeguide-table-col");
          const $clickedItems = $clickedCol.find(
            ".sizeguide-col-item:not(:first-child)"
          );

          if ($clickedCol.hasClass("active")) {
            $clickedItems.slideUp(300);
            $clickedCol.removeClass("active");
          } else {
            $(".sizeguide-table-col.active")
              .removeClass("active")
              .find(".sizeguide-col-item:not(:first-child)")
              .slideUp(300);

            $clickedCol.addClass("active");
            $clickedItems.slideDown(300, function () {
              $(this).css("display", "flex"); // Ensure flex after animation
            });
          }
        });
    } else {
      $(".sizeguide-table-col").each(function () {
        $(this)
          .find(".sizeguide-col-item")
          .stop(true, true) // stop any animations in progress
          .css("display", "flex"); // apply flex
        $(this).removeClass("active");
      });

      $(".sizeguide-table-col .sizeguide-col-item:first-child").off("click");
    }
  };

  setupAccordion();

  // const messages = {
  //   en: {
  //     email: {
  //       required: "Please enter your email address.",
  //       email: "Please enter a valid email address."
  //     }
  //   },
  //   de: {
  //     email: {
  //       required: "Bitte gib deine E-Mail-Adresse ein.",
  //       email: "Please enter a valid email address."
  //     }
  //   },
  //   fr: {
  //     email: {
  //       required: "Please enter your email address.",
  //       email: "Please enter a valid email address."
  //     }
  //   },
  //   it: {
  //     email: {
  //       required: "Please enter your email address.",
  //       email: "Please enter a valid email address."
  //     }
  //   }
  // };

  // // Initialize validation
  // let validator = $("#Klaviyo-ContactFooter").validate({
  //   rules: {
  //     email: {
  //       required: true,
  //       email: true
  //     }
  //   },
  //   messages: messages.de // Default to German
  // });

  jQuery.extend(jQuery.validator.messages, {
    required: "Dieses Feld ist erforderlich.",
    email: "Bitte gib eine gültige E-Mail Adresse ein.",
    accept: "Bitte fügen Sie einen gültigen Dateityp hinzu.",
    maxlength: "Diese Telefonnummer ist unvollständig.",
  });

  if ($("body").hasClass("template-name--newsletter")) {
    let newsletter_email = getParameterByName("_eq");
    if (newsletter_email != null && newsletter_email != "") {
      newsletter_email = atob(newsletter_email);
      $('#NewsletterForm input[type="email"]').val(newsletter_email);
      $('#Klaviyo-ContactFooter input[type="email"]').val(newsletter_email);
    }
  }
});

$(window).on("resize", () => setupAccordion());

// iFrameResize
document.addEventListener("DOMContentLoaded", function () {
  iFrameResize(
    {
      log: false,
      checkOrigin: false,
      autoResize: true,
      heightCalculationMethod: "lowestElement",
    },
    "#jobsIframe"
  );
});

class CardSwatches {
  constructor(elm) {
    this.elm = elm;
    this.elm._cardSwatches = this;

    // store bound handlers so removeEventListener works
    this.boundHandleChange = this.handleChange.bind(this);
    this.boundHandleClick = this.handleClick.bind(this);
    this.boundPointerDown = (e) => e.stopPropagation();

    const dataEl = this.elm.querySelector('[id*="product-data-"]');
    if (dataEl) {
      this.productData = JSON.parse(dataEl.textContent);
    }

    this.swatchInputs = Array.from(
      this.elm.querySelectorAll('input[type="radio"]')
    );
    if (this.swatchInputs.length > 0) {
      this.activeSwatch = this.swatchInputs.find((input) => input.checked);
      this.selectedValue = this.activeSwatch?.value;
      if (this.selectedValue) this.updateDetails(this.selectedValue);
    }

    // initialize once
    this.swatchesInitialized = false;
    this.initializeSwatches();

    // Swiper
    this.swiperInstance = this.elm.querySelector(".card__media_slider");
    if (this.swiperInstance) {
      // scope nav to this card (avoid global ID conflicts)
      const nextEl = this.elm.querySelector(".swiper-button-next");
      const prevEl = this.elm.querySelector(".swiper-button-prev");

      this.swiper = new Swiper(this.swiperInstance, {
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: false,
        preventClicks: false,
        preventClicksPropagation: false,
        touchStartPreventDefault: false,
        // noSwipingSelector still present so that swatches are treated as no-swipe
        noSwiping: true,
        noSwipingSelector:
          '.swatch, .swatch-input, .swatch-input__label, input[type="radio"]',
        navigation: {
          nextEl,
          prevEl,
        },
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        on: {
          init: () => this.initializeSwatches(),
          slideChange: () => this.initializeSwatches(),
          lazyImageReady: () => this.initializeSwatches(),
        },
      });
    }
  }

  initializeSwatches() {
    if (this.swatchesInitialized) return;

    this.swatchInputs = Array.from(
      this.elm.querySelectorAll('input[type="radio"]')
    );
    this.swatchInputs.forEach((input) => {
      // remove existing using stored refs
      input.removeEventListener("change", this.boundHandleChange);
      input.removeEventListener("click", this.boundHandleClick);
      input.removeEventListener("pointerdown", this.boundPointerDown);

      // add handlers using stored refs
      input.addEventListener("change", this.boundHandleChange);
      input.addEventListener("click", this.boundHandleClick);
      // stop propagation early so swiper won't treat it as a drag
      input.addEventListener("pointerdown", this.boundPointerDown);

      // also stop pointerdown on label (if present)
      const label = this.elm.querySelector(`label[for="${input.id}"]`);
      if (label) {
        label.removeEventListener("pointerdown", this.boundPointerDown);
        label.addEventListener("pointerdown", this.boundPointerDown);
      }
    });

    this.swatchesInitialized = true;
  }

  handleClick(e) {
    e.stopPropagation();
    this.handleChange(e);
  }

  handleChange(evt) {
    const target = evt.target.closest
      ? evt.target.closest('input[type="radio"]')
      : evt.target;
    if (!target) return;
    this.selectedValue = target.value;
    this.updateDetails(this.selectedValue);
  }

  updateDetails(value) {
    const selectedVariant = this.productData?.variants?.find(
      (variant) => variant.options.includes(value) && variant.available
    );

    if (!selectedVariant) return;

    // Update product link
    const productLink = this.elm.querySelector('a[href*="/products/"]');
    if (productLink) {
      const baseUrl = productLink.href.split("?")[0];
      productLink.href = `${baseUrl}?variant=${selectedVariant.id}`;
    }

    // Update images using the existing gallery function
    const color_name = value.replace(/\s+/g, "_");
    change_image_gallery(color_name, this);

    // Update Swiper after DOM changes
    if (this.swiper) {
      this.swiper.update();
      this.swiper.slideTo(0);
    }

    // Re-initialize swatches after DOM changes
    this.swatchesInitialized = false;
    this.initializeSwatches();
  }
}

function change_image_gallery(color, $this) {

  // if (!$this || !$this.productData) return;

  if(typeof $this === 'undefined'){
    $(`[data-color_name="${color}"]`).siblings("li").addClass("hidden");
    $(`[data-color_name="${color}"]`).removeClass("hidden");

    $(`[data-color_name="${color}"]`).siblings("li").find(".gallery").removeAttr("data-fancybox");
    $(`[data-color_name="${color}"]`).find(".gallery").attr("data-fancybox", "gallery");
    setTimeout(function () {
      if (typeof window.initSwiper === "function") {
        window.initSwiper();
      }
    }, 500);
    applyResponsiveWidth();
  }else{
    const product_id = $this.productData.id;
    const product_class = `.product-${product_id}`;
    const cardWrapper = $this.elm;

    // Hide all product images first
    $(cardWrapper)
      .find(`${product_class}[data-color], ${product_class}[data-color_name]`)
      .addClass("hidden");

    // Show the selected color image
    const selectedImage = $(cardWrapper).find(
      `${product_class}[data-color="${color}"], ${product_class}[data-color_name="${color}"]`
    );

    if (selectedImage.length > 0) {
      selectedImage.removeClass("hidden");
    } else {
      const fallbackImage = $(cardWrapper).find(
        `${product_class}[data-color*="${color}"], ${product_class}[data-color_name*="${color}"]`
      );
      if (fallbackImage.length > 0) {
        fallbackImage.removeClass("hidden");
      }
    }

    // Update all product links in this card
    $(cardWrapper)
      .find('a[href*="/products/"]')
      .each(function () {
        const $link = $(this);
        const baseUrl = $link.attr("href").split("?")[0];
        const selectedVariant = $this.productData.variants.find(
          (variant) =>
            variant.options.includes($this.selectedValue) && variant.available
        );

        if (selectedVariant) {
          $link.attr("href", `${baseUrl}?variant=${selectedVariant.id}`);
        }
      });
  }
}

const applyResponsiveWidth = () => {
  const windowWidth = $(window).width();

  if (windowWidth >= 768 && windowWidth <= 1280) {
    $(".mainProduct-wrap .product--stacked .product__media-list .grid__item")
      .css("width", "") // Reset all first
      .filter(":visible")
      .each((index, element) => {
        if (index % 3 === 0) {
          // Every 3rd visible item
          $(element).css("width", "100%");
          $(element).css("max-width", "100%");
        }
      });
  } else {
    // Reset when outside the range
    $(".mainProduct-wrap .product--stacked .product__media-list .grid__item")
      .css("width", "")
      .css("max-width", "");
  }
};

// Run on load and on resize
$(window).on("resize", applyResponsiveWidth);

window.addEventListener("DOMContentLoaded", () => {
  // Add CSS for image switching
  const style = document.createElement("style");
  style.textContent = `
    .product-card-wrapper .hidden {
      display: none !important;
    }
  `;
  document.head.appendChild(style);

  document.querySelectorAll(".product-card-wrapper").forEach((elm) => {
    new CardSwatches(elm);
  });

  // Global event delegation as fallback for swatch clicks
  document.addEventListener("click", (e) => {
    // Check if clicked element is a swatch input or label
    const swatchInput = e.target.closest('input[type="radio"]');
    const swatchLabel = e.target.closest(".swatch-input__label, .swatch");

    if (swatchInput || swatchLabel) {
      const cardWrapper = e.target.closest(".product-card-wrapper");
      if (cardWrapper) {
        // Find the CardSwatches instance for this card
        const cardSwatches = cardWrapper._cardSwatches;
        if (cardSwatches && cardSwatches.handleChange) {
          const targetInput =
            swatchInput || swatchLabel.querySelector('input[type="radio"]');
          if (targetInput) {
            targetInput.checked = true;
            cardSwatches.handleChange({ target: targetInput });
          }
        }
      }
    }
  });
});

// getWindowsScrollbarWidth ----------------------
const initScrollbarWidth = () => {
  const getWindowsScrollbarWidth = () =>
    window.innerWidth - document.documentElement.clientWidth;

  const setScrollbarWidth = () => {
    const windowsScrollbarWidth = getWindowsScrollbarWidth();
    $("body").css("--windows-scrollbar-width", `${windowsScrollbarWidth}px`);
  };

  $(document).ready(() => setScrollbarWidth());
  $(window).resize(() => setScrollbarWidth());
};

initScrollbarWidth();
// End getWindowsScrollbarWidth ----------------------

// Sticky ATC on mobile pdp ----------------------
function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

const setFixedClass = () => {
  const $prodSect = $(".main-product-section .nilepoints-block");
  const $prodSect2 = $(".main-product-section");
  if ($prodSect.length) {
    const sectionBottom =
      $prodSect.offset().top + $prodSect.outerHeight() - 200;
    const scrollTop = $(window).scrollTop();

    // Add 'is-fixed' until the bottom of the section touches the top of the viewport
    const isBeforeBottom = scrollTop < sectionBottom;

    $prodSect2
      .find(".fixed-cta-wrapper")
      .toggleClass("is-fixed", isBeforeBottom);
  }
};

$(window).on("scroll", setFixedClass);
setFixedClass(); // Initial check
$(document).ready(() => {
  setFixedClass(); // Initial check
});

function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2]);
}

window.setCookie = function (cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toGMTString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

window.getCookie = function (cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var cookieArray = decodedCookie.split(";");
  for (var i = 0; i < cookieArray.length; i++) {
    var cookieItem = cookieArray[i];
    while (cookieItem.charAt(0) === " ") {
      cookieItem = cookieItem.substring(1);
    }
    if (cookieItem.indexOf(name) === 0) {
      return cookieItem.substring(name.length, cookieItem.length);
    }
  }
  return "";
};

// end Sticky ATC on mobile pdp ----------------------

// ------------------------------
const setEqualHeights = () => {
  if (window.matchMedia("(min-width: 769px)").matches) {
    $(".sizeguide-table-row").each(function () {
      const $row = $(this);
      const totalCols = $row
        .find(".sizeguide-table-col")
        .first()
        .find(".sizeguide-col-item").length;

      // Reset CSS variables
      for (let i = 1; i <= totalCols; i++) {
        $row.css(`--col-${i}-height`, "auto");
      }

      // Calculate and set max height for each column
      for (let i = 1; i <= totalCols; i++) {
        let maxHeight = 0;
        $row
          .find(`.sizeguide-table-col .sizeguide-col-item:nth-child(${i})`)
          .each(function () {
            maxHeight = Math.max(maxHeight, $(this).outerHeight());
          });
        $row.css(`--col-${i}-height`, `${maxHeight}px`);
      }
    });
  } else {
    // Reset heights on smaller screens
    $(".sizeguide-table-row").removeAttr("style");
  }
};

const setupAccordion = () => {
  if (window.innerWidth <= 768) {
    $(".sizeguide-table-col").each(function () {
      $(this).find(".sizeguide-col-item:not(:first-child)").hide();
      $(this).removeClass("active");
    });

    $(".sizeguide-table-col .sizeguide-col-item:first-child")
      .off("click")
      .on("click", function () {
        const $clickedCol = $(this).closest(".sizeguide-table-col");
        const $clickedItems = $clickedCol.find(
          ".sizeguide-col-item:not(:first-child)"
        );

        if ($clickedCol.hasClass("active")) {
          $clickedItems.slideUp(300);
          $clickedCol.removeClass("active");
        } else {
          $(".sizeguide-table-col.active")
            .removeClass("active")
            .find(".sizeguide-col-item:not(:first-child)")
            .slideUp(300);

          $clickedCol.addClass("active");
          $clickedItems.slideDown(300, function () {
            $(this).css("display", "flex"); // Ensure flex after animation
          });
        }
      });
  } else {
    $(".sizeguide-table-col").each(function () {
      $(this)
        .find(".sizeguide-col-item")
        .stop(true, true)
        .css("display", "flex");
      $(this).removeClass("active");
    });

    $(".sizeguide-table-col .sizeguide-col-item:first-child").off("click");
  }
};

const openSizeGuideModal = () => {
  const $modal = $(".sizeguide-modal");
  $("body").addClass("sizeguide-modal-open");
  $modal.addClass("show");
  $modal
    .css({ visibility: "visible", opacity: 0 })
    .animate({ opacity: 1 }, 300, () => {
      setupAccordion();
      setEqualHeights();
    });
};

const closeSizeGuideModal = () => {
  const $modal = $(".sizeguide-modal");
  const $dialog = $(".sizeguide-modal-dialog");
  $dialog.css({ transform: "translateY(0)", transition: "none" }); // Reset position
  setTimeout(() => {
    $dialog.css({ transition: "transform 300ms ease" }); // Restore smooth transition after reset
  }, 20); // slight delay to avoid skipping animation

  $("body").removeClass("sizeguide-modal-open");
  $modal.removeClass("show");
  $modal.animate({ opacity: 0 }, 300, () => {
    $modal.css({ visibility: "hidden" });
    setupAccordion();
    setEqualHeights();
  });
};

// Initialize when DOM ready
$(document).ready(() => {
  setEqualHeights();
  setupAccordion();

  $(window).on("resize", () => {
    setupAccordion();
    setEqualHeights();
  });

  $(".sizeguide-wrap .sizeguide-model-trigger").on("click", (e) => {
    e.preventDefault();
    openSizeGuideModal();
  });

  $(".sizeguide-modal-dialog-close-btn-wrap").on("click", () => {
    closeSizeGuideModal();
  });

  // Prevent clicks inside content from bubbling up
  $(".sizeguide-modal-content").on("click", function (e) {
    e.stopPropagation();
  });

  // Close modal when clicking outside the content
  $(".sizeguide-modal").on("click", function () {
    closeSizeGuideModal();
  });
});

$(document).ready(() => {
  const $modal = $(".sizeguide-modal");
  const $dialog = $(".sizeguide-modal-dialog");
  const $content = $(".sizeguide-modal-content"); // assuming content inside dialog and is scrollable

  let startY = 0;
  let currentY = 0;
  let isDragging = false;

  const closeModal = () => {
    $("body").removeClass("sizeguide-modal-open");
    $modal.removeClass("show");
    $modal.animate({ opacity: 0 }, 300, () => {
      $dialog.css({
        transform: "translateY(0)",
        transition: "transform 300ms ease",
      });
      $modal.css({ visibility: "hidden" });
    });
  };

  const handleDragStart = (e) => {
    if (window.matchMedia("(max-width: 768px)").matches) {
      const scrollable = $content; // ✅ Fix: Use the actual scrollable element
      // console.log(scrollable.scrollTop());

      if (scrollable.scrollTop() > 0) {
        isDragging = false; // ❗ Prevent drag if content is not at the top
        return;
      }

      isDragging = true;
      startY = e.type === "touchstart" ? e.touches[0].clientY : e.clientY;
      $dialog.css({ transition: "none" });
    }
  };

  const handleDragMove = (e) => {
    if (!isDragging) return;
    currentY = e.type === "touchmove" ? e.touches[0].clientY : e.clientY;
    const deltaY = Math.max(currentY - startY, 0);
    $dialog.css({ transform: `translateY(${deltaY}px)` });
  };

  const handleDragEnd = () => {
    if (!isDragging) return;
    isDragging = false;

    const deltaY = Math.max(currentY - startY, 0);
    const threshold = $content.outerHeight() * 0.2;

    if (deltaY > threshold) {
      closeModal();
    } else {
      $dialog.css({
        transform: "translateY(0)",
        transition: "transform 300ms ease",
      });
    }
  };

  // ✅ Bind events to the *scrollable* element (or its content)
  $dialog.on("touchstart", handleDragStart);
  $dialog.on("touchmove", handleDragMove);
  $dialog.on("touchend touchcancel", handleDragEnd);

  // Optional for desktop testing
  $dialog.on("mousedown", handleDragStart);
  $(document).on("mousemove", handleDragMove);
  $(document).on("mouseup", handleDragEnd);
});

// ------------------------------
